import {i18n} from 'src/boot/i18n';

export default [
  {
    path: '',
    component: () => import('./AmbitusDetector.vue'),
    name: 'Ambitus',
    meta: {
      title: i18n.t('routes.ambitus'),
    },
  },
];
